export const PRIMARY_OPTIONS = [
  { label: "I'm in high school", value: "high_school" },
  {
    label: "I have finished high school and am not in college",
    value: "finished_hs",
  },
  { label: "I am in college or a trade school", value: "college" },
  {
    label: "I have graduated from college and am working professionally",
    value: "graduate",
  },
  {
    label: "I am working professionally and am mid-late career",
    value: "mid_career",
  },
];

export const SECONDARY_OPTIONS: Record<
  string,
  { label: string; value: string }[]
> = {
  high_school: [
    {
      label: "I don't know what I want to do after graduating",
      value: "unknown",
    },
    {
      label: "I don't want to go to college or trade school",
      value: "no_college",
    },
    {
      label:
        "I want to go to college or trade school, and I don't know what to study",
      value: "college_unknown",
    },
    {
      label:
        "I want to go to college or trade school, and know what I want to study",
      value: "college_known",
    },
    { label: "Other", value: "other" },
  ],
  finished_hs: [
    { label: "I don't know what I want to do.", value: "unknown" },
    {
      label: "I don't want to go to college or trade school.",
      value: "no_college",
    },
    {
      label:
        "I want to go to college or trade school, and I don't know what to study.",
      value: "college_unknown",
    },
    {
      label:
        "I want to go to college or trade school, and know what I want to study.",
      value: "college_known",
    },
    { label: "Other", value: "other" },
  ],
  college: [
    {
      label: "I have not made a decision on what to study or declared a major.",
      value: "undecided",
    },
    {
      label: "I have declared my major, and I am confident in my decision.",
      value: "major_confident",
    },
    {
      label: "I have declared my major, and I am not confident in my decision.",
      value: "major_not_confident",
    },
    { label: "Other", value: "other" },
  ],
  graduate: [
    { label: "I am working in my field of study.", value: "in_field" },
    { label: "I am not in my field of study.", value: "not_in_field" },
    {
      label: "I am thinking about switching career paths.",
      value: "switching",
    },
    { label: "Other", value: "other" },
  ],
  mid_career: [
    { label: "I am working in my field of study.", value: "in_field" },
    { label: "I am not in my field of study.", value: "not_in_field" },
    {
      label: "I am thinking about switching career paths.",
      value: "switching",
    },
    { label: "Other", value: "other" },
  ],
};
